/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_UnderlineInputs */

const en_forms_rule_sets_edit_underline = /** @type {(inputs: Forms_Rule_Sets_Edit_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline`)
};

const de_forms_rule_sets_edit_underline = /** @type {(inputs: Forms_Rule_Sets_Edit_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstreichen`)
};

/**
* | output |
* | --- |
* | "Underline" |
*
* @param {Forms_Rule_Sets_Edit_UnderlineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_underline = /** @type {((inputs?: Forms_Rule_Sets_Edit_UnderlineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_UnderlineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_underline(inputs)
	return de_forms_rule_sets_edit_underline(inputs)
});